<template>
  <section class="section-padding section-bg" id="section_2">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="custom-text-box">
            <template v-if="$i18n.locale === 'en'">
              <p><b> Privacy Policy </b></p>
              <p>
                DIVERSE CARE NOW is committed to safeguarding the privacy of our
                users. We want to assure you that we do not share your personal
                information with third parties. This privacy policy outlines how
                we collect, use, and protect the information you provide to us.
              </p>

              <p><b> Information Collection: </b></p>

              <p>
                We collect only the information necessary to provide and improve
                our services. This may include name, email address, etc. We do not
                sell, rent, or share this information with any third parties.
              </p>

              <p><b> How We Use Your Information: </b></p>

              <p>
                The information collected is used solely for communicating with
                the intended party. We do not share your information with external
                parties for marketing or any other purposes.
              </p>

              <p><b> Your Choices: </b></p>

              <p>
                You have the right to access, correct, or delete your information.
                If you have any concerns or questions about your data, please
                contact us at (754) 752-1888.
              </p>
              <p><b> Policy Changes: </b></p>

              <p>
                We may update our privacy policy from time to time. Any changes
                will be communicated to you, and your continued use of our
                services implies your acceptance of the updated policy. By using
                our services, you agree to the terms outlined in this privacy
                policy.
              </p>
              <p>Last updated: JULY 29, 2024</p>
            </template>
            <template v-else>
              <p><b> Política de Privacidade </b></p>
              <p>
                A DIVERSE CARE NOW está comprometida em proteger a privacidade de nossos
                usuários. Queremos garantir que não compartilhamos suas informações pessoais
                com terceiros. Esta política de privacidade descreve como
                coletamos, usamos e protegemos as informações que você nos fornece.
              </p>

              <p><b> Coleta de Informações: </b></p>

              <p>
                Coletamos apenas as informações necessárias para fornecer e melhorar
                nossos serviços. Isso pode incluir nome, endereço de e-mail, etc. Não
                vendemos, alugamos ou compartilhamos essas informações com terceiros.
              </p>

              <p><b> Como Usamos Suas Informações: </b></p>

              <p>
                As informações coletadas são usadas exclusivamente para comunicação com
                a parte pretendida. Não compartilhamos suas informações com partes externas
                para marketing ou quaisquer outros fins.
              </p>

              <p><b> Suas Escolhas: </b></p>

              <p>
                Você tem o direito de acessar, corrigir ou excluir suas informações.
                Se você tiver alguma dúvida ou pergunta sobre seus dados, por favor
                entre em contato conosco pelo (754) 752-1888.
              </p>
              <p><b> Alterações na Política: </b></p>

              <p>
                Podemos atualizar nossa política de privacidade de tempos em tempos. Quaisquer alterações
                serão comunicadas a você, e o uso contínuo de nossos
                serviços implica sua aceitação da política atualizada. Ao usar
                nossos serviços, você concorda com os termos descritos nesta política de
                privacidade.
              </p>
              <p>Última atualização: 29 DE JULHO DE 2024</p>
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PrivacyPage",
};
</script>